import Plyr from "plyr";
import Hls from "hls.js";

const initVideo = (video: HTMLVideoElement) => {
  new Plyr(video, JSON.parse(video.dataset.config || "{}"));

  if (!video.dataset.hlsManifest) {
    return;
  }

  if (!Hls.isSupported()) {
    video.src = video.dataset.hlsManifest;
  } else {
    const hls = new Hls();
    hls.loadSource(video.dataset.hlsManifest);
    hls.attachMedia(video);
  }
};

const videos = document.querySelectorAll<HTMLVideoElement>("video.js-video");

export default videos.forEach(initVideo);
